import { Dialog, Transition } from '@headlessui/react';
import { IconEdit, IconX } from '@tabler/icons-react';
import { Tooltip } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuthorizationHeader, http, imageBaseUrl } from '../../config/http';
import { CurrencyInput } from '../../utils/CurrencyInput';
import ImageComponent from '../../utils/ImageComponent';
import EditTrxPembelian from './EditTrxPembelian';
import { PhotoView } from 'react-photo-view';

export default function DetailTransaksiPembelian({
  // kodeTransaksi,
  closeModal,
  // isSubmitBarangOpname,
  isOpen,
  // addToOpname,
  detailPembelian,
  // handleOnChangeTeknisi,
}) {
  // console.log('detailPembelian::: ', detailPembelian);
  const navigate = useNavigate();
  const [getTeknisiName, setGetTeknisiName] = useState([]);

  // const [cabang_id, setCabangId] = useState('');
  const [harga_modal, setHargaModal] = useState(0);
  const [loadingTransfer, setLoadingTransferBarang] = useState(false);

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function fakeClose() {}

  // async function handleSubmitTranferItem(e) {
  //   e.preventDefault();
  //   const data = { cabang_id, harga_modal };
  //   setLoadingTransferBarang(true);
  //   try {
  //     const response = await http.post(`/pembelian/transfer_item/${kodeTransaksi}`, data, {
  //       headers: { Authorization: getAuthorizationHeader() },
  //     });
  //     toast.success(response.data.message);
  //     closeModal();
  //     setLoadingTransferBarang(false);
  //     return response.data;
  //   } catch (error) {
  //     // console.log('error::: ', error);
  //     if (error.response.status === 401) {
  //       navigate('/login');
  //     } else if (error.response.status === 409) {
  //       toast.error(error.response.data.message);
  //     } else if (error.response.status === 422) {
  //       toast.error('Silahkan Masukkan Form Transfer Barang');
  //     }
  //   }
  //   setLoadingTransferBarang(false);
  // }

  // useEffect(() => {
  //   async function getTeknisi() {
  //     await http
  //       .get(`teknisi`, {
  //         headers: { Authorization: getAuthorizationHeader() },
  //       })
  //       .then((res) => {
  //         setGetTeknisiName(res.data.data);
  //       })
  //       .catch((err) => {
  //         if (err.response === 'undefined') {
  //           return null;
  //         } else if (err.response.status === 401) {
  //           navigate('/login');
  //         }
  //       });
  //   }
  //   getTeknisi();
  // }, [navigate]);

  // const [cabang, setCabang] = useState([]);

  // useEffect(() => {
  //   async function getCabangSelect() {
  //     await http
  //       .get(`cabang`, {
  //         headers: { Authorization: getAuthorizationHeader() },
  //       })
  //       .then((res) => {
  //         setCabang(res.data.data);
  //       })
  //       .catch((err) => {
  //         if (err.response === 'undefined') {
  //           return null;
  //         } else if (err.response.status === 401) {
  //           navigate('/login');
  //         }
  //       });
  //   }
  //   getCabangSelect();
  // }, [navigate]);

  const [load, setLoad] = useState(false);
  const [openImage, setOpenImage] = useState(false);

  const harga_beli_gram = detailPembelian.total_harga / detailPembelian.berat;

  // let [isOpenEditTrx, setIsOpenEditTrx] = useState(false)

  // function closeModalEditTrx() {
  //   setIsOpenEditTrx(false)
  // }

  // function openModalEditTrx() {
  //   setIsOpenEditTrx(true)
  // }

  return (
    <>
      {/* <EditTrxPembelian detailPembelian={detailPembelian} isOpenEditTrx={isOpenEditTrx} closeModalEditTrx={closeModalEditTrx}/> */}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={fakeClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity" />
          </Transition.Child>
          {openImage && isOpen && (
            <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20  flex flex-col items-center justify-center">
              <div
                onClick={() => setOpenImage(false)}
                className={'absolute top-52 right-7 lg:top-16 lg:right-[280px] md:right-[120px] md:top-28 '}
              >
                <div className="bg-white p-2 rounded-full cursor-pointer hover:bg-white/50">
                  <IconX />
                </div>
              </div>
              <div>
                {!load && (
                  <div className="max-w-[48px] max-h-[48px]  rounded-full animate-spin border-4 border-dashed border-green-500 border-t-transparent"></div>
                )}
                <img
                  onLoad={() => setLoad(true)}
                  width={''}
                  className={'lg:w-[700px] md:w-[500px] w-[350px] scale-50'}
                  height={''}
                  src={detailPembelian.gambar === null ? '' : `${imageBaseUrl}${detailPembelian.gambar[0].asli}`}
                />
              </div>
            </div>
          )}
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-xl bg-white dark:bg-slate-900 border dark:border-slate-700 p-6 text-left align-middle shadow-xl transition-all">
                  <div className="mb-4 pb-4 border-b border-slate-100 dark:border-slate-800 flex items-start justify-between gap-3">
                    <div className="flex-1">
                      <Dialog.Title as="h2" className="text-xl font-bold leading-6 text-slate-900 dark:text-slate-100">
                        Detail Pembelian
                      </Dialog.Title>
                      <div className="text-sm text-slate-500 dark:text-slate-400 mt-1">
                        Faktur: <span className="font-semibold text-amber-600 dark:text-amber-500 tracking-wide">{detailPembelian.kode_trx}</span>
                      </div>
                    </div>
                    <div className="flex items-start gap-2 shrink-0">
                      {/* Gambar */}
                      {isOpen && detailPembelian.gambar && detailPembelian.gambar.length > 0 ? (
                        <div className="relative group rounded-lg overflow-hidden border-2 border-amber-200 dark:border-amber-700/50 bg-white dark:bg-slate-900 shadow-sm transition-all hover:border-amber-400 hover:shadow-md cursor-zoom-in">
                          <PhotoView src={`${imageBaseUrl}${detailPembelian.gambar[0]?.asli}`}>
                            <img
                              className="w-[60px] h-[60px] object-cover opacity-90 group-hover:opacity-100 transition-opacity"
                              src={`${imageBaseUrl}${detailPembelian.gambar[0]?.asli}`}
                              alt="Foto Barang"
                            />
                          </PhotoView>
                          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors pointer-events-none"></div>
                        </div>
                      ) : (
                        <div className="w-[60px] h-[60px] rounded-lg border border-dashed border-slate-300 dark:border-slate-600 bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400 text-[10px] text-center px-1">
                          No Image
                        </div>
                      )}
                      {/* Close Button */}
                      <button
                        onClick={closeModal}
                        className="p-1.5 rounded-md text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:text-slate-300 dark:hover:bg-slate-800 transition-colors focus:outline-none"
                        title="Tutup"
                      >
                        <IconX size={20} stroke={2} />
                      </button>
                    </div>
                  </div>
                  <div className="grid gap-2">
                    <div>
                      <div className="border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden bg-white dark:bg-slate-800">
                        <div className="px-4 py-3 flex justify-between items-center border-b border-slate-200 dark:border-slate-700 bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-500 font-semibold text-sm">
                          <h2>Informasi Barang</h2>
                        </div>
                        <div className="border-b border-slate-100 dark:border-slate-700/60 mt-1 text-sm font-medium text-slate-500 dark:text-slate-400 flex justify-between px-4 py-2">
                          Nama Barang
                          <div className="text-slate-900 dark:text-slate-100 text-right">
                            <div className="text-amber-600 dark:text-amber-500 font-semibold">{detailPembelian.jenis_kategori?.nama_jenis}</div>
                          </div>
                        </div>

                        <div className="border-b border-slate-100 dark:border-slate-700/60 text-sm font-medium text-slate-500 dark:text-slate-400 flex justify-between px-4 py-2">
                          Berat
                          <div className="text-slate-900 dark:text-slate-100 text-right">
                            <div className="font-medium">{detailPembelian.berat} <span className="text-xs text-slate-400">Gram</span></div>
                          </div>
                        </div>

                        <div className="border-b border-slate-100 dark:border-slate-700/60 text-sm font-medium text-slate-500 dark:text-slate-400 flex justify-between px-4 py-2">
                          Emas
                          <div className="text-slate-900 dark:text-slate-100 text-right">
                            <div className="font-medium">{detailPembelian.karat} <span className="text-xs text-slate-400">Karat</span></div>
                          </div>
                        </div>

                        <div className="border-b border-slate-100 dark:border-slate-700/60 text-sm font-medium text-slate-500 dark:text-slate-400 flex justify-between px-4 py-2">
                          Modal Beli / gram
                          <div className="text-slate-900 dark:text-slate-100 text-right">
                            <div className="font-semibold text-emerald-600 dark:text-emerald-500">
                              Rp {numberWithCommas(detailPembelian?.harga_beli == undefined ? '0' : Math.round(harga_beli_gram))}
                            </div>
                          </div>
                        </div>

                        <div className="border-b border-slate-100 dark:border-slate-700/60 text-sm font-medium text-slate-500 dark:text-slate-400 flex justify-between px-4 py-2 bg-slate-50 dark:bg-slate-800/80">
                          Total Harga
                          <div className="text-slate-900 dark:text-slate-100 text-right">
                            <div className="font-bold text-amber-600 dark:text-amber-500">
                              Rp {numberWithCommas(detailPembelian.total_harga == undefined ? '0' : detailPembelian.total_harga)}
                            </div>
                          </div>
                        </div>

                        <div className="border-b border-slate-100 dark:border-slate-700/60 text-sm font-medium text-slate-500 dark:text-slate-400 flex justify-between px-4 py-2">
                          Surat
                          <div className="text-slate-900 dark:text-slate-100 text-right">
                            {detailPembelian.surat === 0 ? (
                              <div className="text-red-500 dark:text-red-400 font-medium">Tidak Bersurat</div>
                            ) : (
                              <div className="text-emerald-500 dark:text-emerald-400 font-medium">Bersurat</div>
                            )}
                          </div>
                        </div>

                        <div className="border-b border-slate-100 dark:border-slate-700/60 text-sm font-medium text-slate-500 dark:text-slate-400 flex justify-between px-4 py-2">
                          Kondisi
                          <div className="text-slate-900 dark:text-slate-100 text-right font-medium">
                            {detailPembelian.kondisi_barang}
                          </div>
                        </div>

                        <div className="text-sm font-medium text-slate-500 dark:text-slate-400 px-4 py-3">
                          Keterangan
                          <p className="text-amber-800 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 rounded-md p-3 text-sm mt-1.5 border border-amber-100 dark:border-amber-800/30 font-normal leading-relaxed">
                            {detailPembelian.keterangan}
                          </p>
                        </div>

                        {/* <div className="mt-2 hidden px-5 mb-2">
                          <select
                            onChange={handleOnChangeTeknisi}
                            name="teknisi_id"
                            className="select select-bordered w-full"
                          >
                            <option>Pilih Teknisi</option>
                            {getTeknisiName.map((tk) => (
                              <option key={tk.id} value={tk.id}>
                                {tk.nama_teknisi}
                              </option>
                            ))}
                          </select>
                        </div> */}
                      </div>
                    </div>
                    {/* <div className="border rounded-md hidden">
                      <div className={`p-1 border-b  bg-green-500/10 text-slate-600  `}>
                        <h2>Transfer Barang</h2>
                      </div>

                      <div className={` `}>
                        <div className="px-3 mt-8">
                          <select
                            onChange={(e) => setCabangId(e.target.value)}
                            className="select select-bordered w-full"
                          >
                            <option className="pt-6">Pilih Etalase</option>
                            {cabang.map((cb) => (
                              <option key={cb.id} value={cb.id}>
                                {cb.nama_cabang}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="px-3 mt-8">
                          <CurrencyInput
                            name="harga_modal"
                            value={harga_modal}
                            onChange={(value) => setHargaModal(() => value)}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          />
                        </div>
                      </div>
                    </div> */}
                  </div>

                  <div className="mt-6 pt-5 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-3">
                    <button
                      className="px-5 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 hover:bg-slate-50 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-600 dark:hover:bg-slate-700 rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-200 dark:focus:ring-offset-slate-900 min-w-[100px]"
                      onClick={closeModal}
                    >
                      Tutup
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
